import { constants } from "../context/constants";
import axiosInstance from "./axiosInstance";

export const signInUser = async ({ email, password }) => {
    try {
        const response = await axiosInstance.post(
            `${constants.USER_SIGNIN}`,
            { email, password }
        );
        if (response.status === 200) return {
            data: response.data,
            loadingLogin: false,
            alertModalShow: true,
        }
    } catch (error) {
        throw error;
    }
}

export const getUser = async ({ headers }) => {
    try {
        const response = await axiosInstance.get(
            `${constants.USER_INFO}`,
            { headers }
        );
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const getCategories = async ({ page, limit, headers } = {}) => {
    try {
        const url = page && limit
            ? `${constants.GET_CATEGORIES}?page=${page}&limit=${limit}`
            : constants.GET_CATEGORIES;
        const response = await axiosInstance.get(url, { headers });
        if (response.status === 200) return {
            data: response.data,
        };
    } catch (error) {
        throw error;
    }
};

export const createCategory = async (categoryDTO, headers) => {
    try {
        const response = await axiosInstance.post(
            constants.GET_CATEGORY,
            categoryDTO,
            { headers }
        );
        if (response.status === 200 && response.data) {
            return {
                data: response.data,
                loadingReq: false,
                alertModalShow: true
            };
        } else {
            throw new Error("La respuesta del servidor no es válida");
        }
    } catch (error) {
        if (error.response) {
            console.log(error.response)
            throw new Error('Error en la solicitud: ' + error.response.data);
        } else if (error.request) {
            throw new Error("No se recibió respuesta del servidor");
        } else {
            throw new Error(`Error en la solicitud: ${error.message}`);
        }
    }
};
export const updateCategory = async (categoryDTO, headers) => {
    try {
        const response = await axiosInstance.put(
            constants.GET_CATEGORY, categoryDTO,
            { headers }
        );
        if (response.status === 200) {
            return {
                data: response.data,
                loadingReq: false,
                alertModalShow: true
            };
        }
    } catch (error) {
        throw error;
    }
}
export const deleteCategory = async (id, headers, confirmProducts = false) => {
    try {
        const response = await axiosInstance.delete(
            `${constants.DELETE_CATEGORY}/${encodeURIComponent(id)}?confirmProducts=${confirmProducts}`,
            { headers }
        );

        if (response.status === 200) {
            return {
                success: true,
                message: constants.CATEGORY_DELETED,
                data: response.data,
            };
        } else {
            throw new Error("La respuesta del servidor no es válida");
        }
    } catch (error) {
        throw error;
    }
};

export const getProduct = async ({ _id }) => {
    try {
        const response = await axiosInstance.get(
            `${constants.GET_PRODUCT_BY_ID}?${constants.PARAMS_PRODUCT + _id}`,
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const getMyMovements = async ({ headers, page }) => {
    try {
        const response = await axiosInstance.get(
            `${constants.USER_MOVEMENTS}?${constants.PARAMS_PAGE + page}`,
            { headers }
        );
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const queryProducts = async ({ query }) => {
    try {
        const response = await axiosInstance.get(
            `${constants.QUERY_PRODUCTS}?${constants.PARAMS_QUERY_PRODUCT + query}`,
        );
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const createProduct = async (productDTO, headers) => {
    try {
        const response = await axiosInstance.post(
            `${constants.CREATE_PRODUCT}`,
            productDTO,
            { headers }
        );
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
            alertModalShow: true
        }
    } catch (error) {
        throw error;
    }
}

export const getAllProducts = async ({ page, filter = 'all', headers } = {}) => {
    try {
        const response = await axiosInstance.get(
            `${constants.GET_ALL_PRODUCTS}?${constants.PARAMS_PAGE + page}&filter=${filter}`,
            { headers }
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const updateProduct = async (productDTO, headers) => {
    try {
        const response = await axiosInstance.put(
            `${constants.CREATE_PRODUCT}`,
            productDTO,
            { headers }
        );
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
            alertModalShow: true
        }
    } catch (error) {
        throw error;
    }
}

export const rechargeWallet = async (email, amount, headers) => {
    try {
        const response = await axiosInstance.post(
            `${constants.POST_RECHARGE_WALLET}`,
            { email, amount },
            { headers }
        );
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
            alertModalShow: true
        }
    } catch (error) {
        throw error;
    }
}

export const rechargeMovements = async ({ page, headers }) => {
    try {
        const response = await axiosInstance.get(
            `${constants.GET_ALL_RECHARGES}?${constants.PARAMS_PAGE + page}`,
            { headers }
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const getTheRecharger = async ({ responsible, headers }) => {
    try {
        const response = await axiosInstance.get(
            `${constants.GET_THE_RECHARGER}?${constants.PARAMS_RESPONSIBLE + responsible}`,
            { headers }
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const getProducts = async ({ headers }) => {
    try {
        const response = await axiosInstance.get(
            `${constants.GET_PRODUCTS}`,
            { headers }
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const getMovements = async ({
    headers,
    page,
    limit,
    search,
    status,
    paymentMethod,
    dateFrom,
    dateTo,
    movementType,
    month,
    sort
} = {}) => {
    const params = new URLSearchParams();
    const query = { page, limit, search, status, paymentMethod, dateFrom, dateTo, movementType, month, sort };

    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.append(key, value);
    });

    const queryString = params.toString();
    const response = await axiosInstance.get(
        queryString ? `${constants.GET_MOVEMENTS}?${queryString}` : constants.GET_MOVEMENTS,
        { headers }
    );

    return { data: response.data };
};

export const getMovementDetail = async ({ headers, identifier } = {}) => {
    const response = await axiosInstance.get(
        `${constants.GET_MOVEMENTS}/${encodeURIComponent(identifier)}`,
        { headers }
    );

    return { data: response.data };
};

export const getAccountsPage = async ({ headers, page, filter = 'all', filters = {} }) => {
    try {
        const params = new URLSearchParams({
            [constants.PARAMS_PAGE.replace('=', '')]: page,
            filter
        });

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') params.append(key, value);
        });

        const response = await axiosInstance.get(
            `${constants.GET_ACCOUNTS}?${params.toString()}`,
            { headers }
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const getPendingDeliveryNeeds = async ({ headers }) => {
    const response = await axiosInstance.get(
        constants.GET_PENDING_DELIVERY_NEEDS,
        { headers }
    );
    return { data: response.data, loadingReq: false };
}

export const createAccount = async ({ headers, accountDTO }) => {
    try {
        const response = await axiosInstance.post(
            `${constants.CREATE_ACCOUNT}`,
            { ...accountDTO },
            { headers }
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const updateAccount = async ({ headers, _id, productID, email, password, profiles, status, note }) => {
    try {
        const response = await axiosInstance.post(
            `${constants.UPDATE_ACCOUNT}`,
            { _id, productID, email, password, profiles, status, note },
            { headers }
        )
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
        }
    } catch (error) {
        throw error;
    }
}

export const getCredentialTemplate = async ({ headers, signal } = {}) => {
    const response = await axiosInstance.get(constants.CREDENTIAL_TEMPLATE, { headers, signal });
    return { data: response.data, loadingReq: false };
};

export const updateCredentialTemplate = async ({ headers, template }) => {
    const response = await axiosInstance.put(
        constants.CREDENTIAL_TEMPLATE,
        { template },
        { headers }
    );
    return { data: response.data, loadingReq: false };
};

export const deleteProduct = async ({ _id, headers, confirmHistorical = false }) => {
    try {
        const response = await axiosInstance.delete(
            `${constants.CREATE_PRODUCT}/${_id}?confirmHistorical=${confirmHistorical}`,
            { headers }
        );

        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
            alertModalShow: true
        };
    } catch (error) {
        throw error;
    }
}

export const restoreProduct = async ({ _id, headers }) => {
    try {
        const response = await axiosInstance.put(
            `${constants.CREATE_PRODUCT}/restore/${_id}`,
            {},
            { headers }
        );

        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
            alertModalShow: true
        };
    } catch (error) {
        throw error;
    }
}

export const getCombos = async ({ headers, page, limit, search, status, lifecycleStatus } = {}) => {
    const params = new URLSearchParams();
    const query = { page, limit, search, status, lifecycleStatus };

    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.append(key, value);
    });

    const queryString = params.toString();
    const response = await axiosInstance.get(
        queryString ? `${constants.GET_COMBOS}?${queryString}` : constants.GET_COMBOS,
        { headers }
    );

    return { data: response.data };
};

export const getComboDetail = async ({ headers, _id } = {}) => {
    const params = new URLSearchParams({ _id });
    const response = await axiosInstance.get(
        `${constants.GET_COMBO}?${params.toString()}`,
        { headers }
    );

    return { data: response.data };
};

export const createCombo = async (comboDTO, headers) => {
    const response = await axiosInstance.post(
        constants.CREATE_COMBO,
        comboDTO,
        { headers }
    );

    return { data: response.data, status: response.status };
};

export const updateCombo = async (comboDTO, headers) => {
    const response = await axiosInstance.put(
        constants.CREATE_COMBO,
        comboDTO,
        { headers }
    );

    return { data: response.data, status: response.status };
};

export const activateCombo = async ({ _id, headers } = {}) => {
    const response = await axiosInstance.put(
        `${constants.ACTIVATE_COMBO}/${encodeURIComponent(_id)}/activate`,
        {},
        { headers }
    );

    return { data: response.data, status: response.status };
};

export const deactivateCombo = async ({ _id, headers } = {}) => {
    const response = await axiosInstance.put(
        `${constants.DEACTIVATE_COMBO}/${encodeURIComponent(_id)}/deactivate`,
        {},
        { headers }
    );

    return { data: response.data, status: response.status };
};

export const deleteCombo = async ({ _id, headers } = {}) => {
    const response = await axiosInstance.delete(
        `${constants.DELETE_COMBO}/${encodeURIComponent(_id)}`,
        { headers }
    );

    return { data: response.data, status: response.status };
};

export const restoreCombo = async ({ _id, headers } = {}) => {
    const response = await axiosInstance.put(
        `${constants.RESTORE_COMBO}/${encodeURIComponent(_id)}`,
        {},
        { headers }
    );

    return { data: response.data, status: response.status };
};

export const uploadImage = async (file, headers) => {
    try {
        const formData = new FormData();
        formData.append('image', file);

        // Authenticated requests normally carry application/json in the
        // Zustand session headers. Keeping that value for FormData prevents
        // the browser from generating the multipart boundary, so Multer sees
        // an empty request. Preserve every other header without mutating the
        // shared session object and let Axios/the browser set Content-Type.
        const multipartHeaders = Object.fromEntries(
            Object.entries(headers || {}).filter(([name]) => name.toLowerCase() !== 'content-type')
        );

        const response = await axiosInstance.post(
            constants.UPLOAD_IMAGE,
            formData,
            { headers: multipartHeaders }
        );
        if (response.status === 200) return {
            data: response.data,
            loadingReq: false,
            alertModalShow: true
        }
    } catch (error) {
        throw error;
    }
}

export const getRechargeSettings = async ({ headers } = {}) => {
    const response = await axiosInstance.get(constants.RECHARGE_SETTINGS, { headers });
    return { data: response.data?.data, status: response.status };
};

export const updateRechargeSettings = async ({ headers, settings } = {}) => {
    const response = await axiosInstance.put(constants.RECHARGE_SETTINGS, settings, { headers });
    return { data: response.data?.data, status: response.status };
};

export const getProfitabilityDashboard = async ({ headers, filters = {} } = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && String(value) !== '') params.set(key, String(value));
    });
    const response = await axiosInstance.get(`${constants.PROFITABILITY}?${params.toString()}`, { headers });
    return { data: response.data?.data || response.data, status: response.status };
};

export const updateProfitabilityProfileCost = async ({ headers, costPerProfile } = {}) => {
    const response = await axiosInstance.put(
        constants.PROFITABILITY_PROFILE_COST,
        { costPerProfile },
        { headers }
    );
    return { data: response.data?.data || response.data, status: response.status };
};

export const getProfitabilityCostCatalog = async ({ headers } = {}) => {
    const response = await axiosInstance.get(constants.PROFITABILITY_COSTS, { headers });
    return { data: response.data?.data || response.data, status: response.status };
};

export const updateProfitabilityProfileCosts = async ({ headers, serviceCosts } = {}) => {
    const response = await axiosInstance.put(
        constants.PROFITABILITY_PROFILE_COSTS,
        { serviceCosts },
        { headers }
    );
    return { data: response.data?.data || response.data, status: response.status };
};

export const getBrebIngestions = async ({
    headers,
    page = 1,
    limit = 20,
    status = '',
    processingStatus = '',
    search = '',
    dateFrom = '',
    dateTo = ''
} = {}) => {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (status) params.set('status', status);
    if (processingStatus) params.set('processingStatus', processingStatus);
    if (search.trim()) params.set('search', search.trim());
    if (dateFrom) params.set('dateFrom', dateFrom);
    if (dateTo) params.set('dateTo', dateTo);
    const response = await axiosInstance.get(
        `${constants.BREB_INGESTIONS}?${params.toString()}`,
        { headers }
    );
    return { data: response.data?.data, status: response.status };
};

export const recalculateBrebIngestion = async ({ headers, id } = {}) => {
    const response = await axiosInstance.post(
        `${constants.BREB_INGESTIONS}/${encodeURIComponent(id)}/recalculate`,
        {},
        { headers }
    );
    return { data: response.data?.data, status: response.status };
};

export const setCommercialUserRole = async ({ headers, email, role } = {}) => {
    const response = await axiosInstance.put(
        constants.COMMERCIAL_USER_ROLE,
        { email, role },
        { headers }
    );
    return { data: response.data, status: response.status };
};

export const getCommercialUsers = async ({
    headers,
    role = '',
    search = '',
    hasBalance = false,
    page = 1,
    limit = 20
} = {}) => {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (role) params.set('role', role);
    if (search.trim()) params.set('search', search.trim());
    if (hasBalance) params.set('hasBalance', 'true');
    const response = await axiosInstance.get(
        `${constants.COMMERCIAL_USERS}?${params.toString()}`,
        { headers }
    );
    return { data: response.data, status: response.status };
};

export const resetCommercialUserPassword = async ({ headers, email, newPassword, actorPassword } = {}) => {
    const response = await axiosInstance.put(
        constants.COMMERCIAL_USER_PASSWORD,
        { email, newPassword, actorPassword },
        { headers }
    );
    return { data: response.data, status: response.status };
};

export const getNotifications = async ({ headers } = {}) => {
    const response = await axiosInstance.get(constants.GET_NOTIFICATIONS, { headers });
    return { data: response.data, status: response.status };
};

export const markNotificationAsRead = async ({ id, headers } = {}) => {
    const response = await axiosInstance.put(
        `${constants.GET_NOTIFICATIONS}/${encodeURIComponent(id)}/read`,
        {},
        { headers }
    );
    return { data: response.data, status: response.status };
};

export const markAllNotificationsAsRead = async ({ headers } = {}) => {
    const response = await axiosInstance.put(
        `${constants.GET_NOTIFICATIONS}/read-all`,
        {},
        { headers }
    );
    return { data: response.data, status: response.status };
};

export const getPushNotificationConfiguration = async ({ headers } = {}) => {
    const response = await axiosInstance.get(
        `${constants.PUSH_NOTIFICATIONS}/config`,
        { headers }
    );
    return { data: response.data, status: response.status };
};

export const registerPushNotificationSubscription = async ({ headers, subscription } = {}) => {
    const response = await axiosInstance.put(
        `${constants.PUSH_NOTIFICATIONS}/subscription`,
        { subscription },
        { headers }
    );
    return { data: response.data, status: response.status };
};

export const removePushNotificationSubscription = async ({ headers, endpoint } = {}) => {
    const response = await axiosInstance.delete(
        `${constants.PUSH_NOTIFICATIONS}/subscription`,
        { headers, data: { endpoint } }
    );
    return { data: response.data, status: response.status };
};
